export type ProductTypeInterface = "ielts" | "fast_track" | "study_material"
export const productType = {
  ielts: "ielts",
  fastTrack: "fast_track",
  selfPrep: "self_prep",
  free: "free",
}
